import type { CSSProperties, ReactNode } from 'react'

interface SectionProps {
  /** Background image URL (public path) or any CSS background value. */
  image?: string
  /** Darkening overlay opacity 0..1. */
  overlay?: number
  /** Text color scheme on top of the background. */
  tone?: 'light' | 'dark'
  /** Stretch to the full viewport height (hero). */
  fullHeight?: boolean
  className?: string
  id?: string
  children?: ReactNode
}

/**
 * A full-bleed page section. With `image` it is a background-image section: cover-fit photo, optional dark overlay, and
 * light or dark text on top.
 */
export default function Section({
  image,
  overlay = 0,
  tone = 'dark',
  fullHeight = false,
  className = '',
  id,
  children,
}: SectionProps) {
  const style: CSSProperties | undefined = image
    ? ({ backgroundImage: `url(${image})`, '--overlay': overlay } as CSSProperties)
    : undefined
  const classes = [
    'section',
    image ? 'bg-cover-section' : '',
    tone === 'light' ? 'text-white' : 'text-black',
    fullHeight ? 'min-h-svh flex flex-col justify-center' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <section id={id} className={classes} style={style}>
      {children}
    </section>
  )
}
